export default {
    "woods": {
        "backgrounds": {
            "tallwall": [
                require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG1-BAKED.lowres.png"),
                require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG2-BAKED.lowres.png"),
                require("@fae/source/assets/images/ember-tactics/env/woods/BG-woods-34-farBG3-BAKED.lowres.png"),
            ],
            // "farwall": require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-30-farBG-example.png"),
            "nearwall": require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-35-nearBG-example.png"),
            "floor": require("@fae/source/assets/images/ember-tactics/env/woods/test/BG-woods-10-floorbasic.png"),
        },
        "colors": {
            "light": "#056167",
            "mid": "#060c14",
            "dark": "#000001",
            // "neardark": "#03050a",
        }
    },
    "cliffs": {
        "backgrounds": {
            "farwall": require("@fae/source/assets/images/ember-tactics/env/cliffs/BG-cliffs-40-farBG.png"),
            "truefloor": require("@fae/source/assets/images/ember-tactics/env/cliffs/BG-cliffs-38-floortexture.png"),
        },
        "colors": {
            "light": "#056167",
            "mid": "#1b1b1c",
            "dark": "#000001",
        }
    },
    "swamp": {
        "backgrounds": {
            "farwall": require("@fae/source/assets/images/ember-tactics/env/swamp/BG-swamp-30-farBG-1.png"),
            "nearwall": require("@fae/source/assets/images/ember-tactics/env/swamp/BG-swamp-28-nearBG-1.png"),
            "floor": require("@fae/source/assets/images/ember-tactics/env/swamp/BG-swamp-50-floortexture1.png"),
        },
        "colors": {
            "light": "#056167",
            "mid": "#021316",
            "dark": "#000001",
        }
    },
    "ruins": {
        "backgrounds": {
            "farwall": require("@fae/source/assets/images/ember-tactics/env/ruins/BG-ashlands-34-farBG.png"),
            "bignearwall": require("@fae/source/assets/images/ember-tactics/env/ruins/BG-ashlands-32-nearBG.png"),
            "floor": require("@fae/source/assets/images/ember-tactics/env/ruins/BG-ashlands-40-floortexture.png"),
        },
        "colors": {
            "light": "#056167",
            "mid": "#0d192b",
            "dark": "#000001",
        }
    },
    "mountain": {
        "backgrounds": {
            "farwall": require("@fae/source/assets/images/ember-tactics/env/mountain/BG-mountain-34-farBG.png"),
            "smallnearwall": require("@fae/source/assets/images/ember-tactics/env/mountain/BG-mountain-30-nearBG.png"),
            "floor": require("@fae/source/assets/images/ember-tactics/env/mountain/BG-mountain-40-floortexture.png"),
        },
        "colors": {
            "light": "#2d527e",
            "mid": "#141c33",
            "dark": "#000001",
        }
    },
}
